// @see https://github.com/mokesmokes/backo

interface BackoffOptions {
  min?: number;
  max?: number;
  jitter?: number;
  factor?: number;
}

export default class Backoff {
  ms: number;
  max: number;
  factor: number;
  jitter: number;
  attempts: number;

  constructor(opts: BackoffOptions) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
  }

  duration(): number {
    let ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
      const rand = Math.random();
      const deviation = Math.floor(rand * this.jitter * ms);
      ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
  }

  reset() {
    this.attempts = 0;
  }

  setMin(min: number) {
    this.ms = min;
  }

  setMax(max: number) {
    this.max = max;
  }

  setJitter(jitter) {
    this.jitter = jitter;
  }
}
